import React from 'react';
import { Tendency } from '../../../Tendency';
import { formatNumber } from "../../../Format";
import {CellTwoLines} from "../../../tables/CellTwoLines";

const DevicesCell = ({devices, refDevices}) => {
  return (<CellTwoLines
    text={isNaN(devices) ? "-" : formatNumber(devices)}
    subtext={
      <Tendency
        value={devices}
        refValue={refDevices}/>
    }/>)
}

export default DevicesCell
